import type { RequestException } from '@eika-infrastruktur/request';
import type { SessionModel } from '@generated-types';
import { getSession } from '@react-query/services/session';
import { useQuery } from '@tanstack/react-query';

export const useSession = () => {
    return useQuery<SessionModel, RequestException>({
        queryKey: ['session'],
        queryFn: () => getSession(),
    });
};
